import { Helmet } from 'react-helmet-async';

const StructuredData = () => {
  const businessData = {
    "@context": "https://schema.org",
    "@type": "TaxiService",
    "name": "StationCab",
    "description": "Service de VTC et Taxi à Paris et Île-de-France. Réservation en ligne, transferts aéroports.",
    "url": "https://stationcab.fr",
    "logo": "https://stationcab.fr/logo192.png",
    "image": "https://stationcab.fr/og-image.png",
    "email": "contact@stationcab.fr",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Paris",
      "addressRegion": "Île-de-France",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "48.8566",
      "longitude": "2.3522"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Paris"
      },
      {
        "@type": "State",
        "name": "Île-de-France"
      }
    ],
    "serviceType": ["VTC", "Taxi", "Transfert aéroport", "Chauffeur privé"],
    "priceRange": "€€",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      "opens": "00:00",
      "closes": "23:59"
    },
    "sameAs": [
      "https://www.facebook.com/stationcab",
      "https://www.instagram.com/stationcab"
    ]
  };

  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Comment réserver un VTC à Paris ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Réservez en ligne sur stationcab.fr en indiquant votre adresse de départ et destination. Vous obtenez un tarif fixe immédiatement."
        }
      },
      {
        "@type": "Question",
        "name": "Quels sont les tarifs pour un transfert aéroport ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Les tarifs varient selon la distance. Un transfert Paris-CDG coûte environ 50-70€, Paris-Orly environ 35-50€. Tarif fixe garanti à la réservation."
        }
      },
      {
        "@type": "Question",
        "name": "Acceptez-vous les paiements par carte ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Oui, nous acceptons les paiements par carte bancaire (Visa, Mastercard) directement dans l'application, ainsi que les espèces."
        }
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(businessData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
